import { Room as LocationIcon } from "@mui/icons-material"; // Location Pin Icon
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
const isVideoFile = (fileUrl) => {
  return /\.(mp4|mov|avi|mkv|webm)$/i.test(fileUrl);
};

const ReviewDialog = ({ open, onClose, rowData, onSave }) => {
  const [updatedCategory, setUpdatedCategory] = useState(
    rowData?.Category || ""
  );
  const [updatedPriority, setUpdatedPriority] = useState(
    rowData?.Priority || ""
  );

  const categories = ["Law Enforcement", "Behavioral", "Public Safety"];
  const priorities = ["Critical", "High", "Medium", "Low"];

  const handleSave = () => {
    const updatedData = {
      ...rowData,
      Category: updatedCategory,
      Priority: updatedPriority,
    };
    onSave(updatedData);
  };

  // Format Media Files for ReactImageGallery
  // const galleryItems =
  //   rowData?.MediaFiles?.map((file) => {
  //     if (file.type === "image") {
  //       return {
  //         original: file.url,
  //         thumbnail: file.url,
  //       };
  //     } else if (file.type === "video") {
  //       return {
  //         original: file.url,
  //         thumbnail: file.url,
  //         renderItem: () => (
  //           <video
  //             controls
  //             style={{ width: "100%", height: "100%", objectFit: "contain" }}
  //           >
  //             <source src={file.url} type="video/mp4" />
  //             Your browser does not support the video tag.
  //           </video>
  //         ),
  //       };
  //     }
  //     return null;
  //   }) || [];

  const galleryItems = rowData?.MediaFiles?.map((media) => {
    if (isVideoFile(media.url)) {
      // Handle video
      return {
        original: media.url,
        thumbnail: media.thumbnail || "https://via.placeholder.com/150",
        embedUrl: media.url,
        renderItem: () => (
          <video
            controls
            style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
          >
            <source
              src={media.url}
              type={`video/${media.url.split(".").pop()}`}
            />
            Your browser does not support the video tag.
          </video>
        ),
      };
    } else {
      // Handle image
      return {
        original: media.url,
        thumbnail: media.url,
      };
    }
  });
  const openGoogleMaps = (latitude, longitude) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    const googleMapsAppUrl = `geo:${latitude},${longitude}`;

    // Check if the device is mobile based on screen width and userAgent
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth < 768;

    if (isMobile) {
      // Try opening the Google Maps mobile app
      window.location.href = googleMapsAppUrl;
    } else {
      // Fallback to opening Google Maps in a new tab
      window.open(googleMapsUrl, "_blank");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>View Media & Update Details</DialogTitle>
      <DialogContent>
        {/* Media Files Carousel */}
        <Box
          sx={{
            marginBottom: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "600px",
              height: "400px",
              maxWidth: "100%",
              overflow: "hidden",
              "& .image-gallery-slide img": {
                width: "100%",
                height: "100%",
                objectFit: "contain",
              },
            }}
          >
            {galleryItems?.length > 0 ? (
              <ReactImageGallery
                items={galleryItems}
                showThumbnails
                showFullscreenButton
                showPlayButton={false}
                slideDuration={500}
              />
            ) : (
              <Typography>No Media Files Available</Typography>
            )}
          </Box>
        </Box>

        {/* Two-Column Layout for Fields */}
        <Grid container spacing={2}>
          {/* First Column */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Date"
              value={rowData?.Date || ""}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="User ID"
              value={rowData?.["User ID"] || ""}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Case ID"
              value={rowData?.["Case ID"] || ""}
              fullWidth
              margin="normal"
              disabled
            />
          </Grid>

          {/* Second Column */}
          <Grid item xs={12} sm={6}>
            <div style={{ display: "flex", gap: "4px" }}>
              <TextField
                label="Location"
                value={rowData?.Location || ""}
                fullWidth
                margin="normal"
                disabled
              />
              {rowData?.latitude && rowData?.longitude && (
                <Button
                  onClick={() =>
                    openGoogleMaps(rowData.latitude, rowData.longitude)
                  }
                  color="primary"
                  sx={{
                    minWidth: "auto",
                    marginLeft: "10px",
                  }}
                >
                  <LocationIcon fontSize="large" />
                </Button>
              )}
            </div>
            <TextField
              label="Status"
              value={rowData?.Status || ""}
              fullWidth
              margin="normal"
              disabled
            />
            {/* Editable Category Dropdown */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Category</InputLabel>
              <Select
                value={updatedCategory}
                onChange={(e) => setUpdatedCategory(e.target.value)}
                label="Category"
              >
                {categories.map((cat) => (
                  <MenuItem key={cat} value={cat}>
                    {cat}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Editable Priority Dropdown */}
            <FormControl fullWidth margin="normal">
              <InputLabel>Priority</InputLabel>
              <Select
                value={updatedPriority}
                onChange={(e) => setUpdatedPriority(e.target.value)}
                label="Priority"
              >
                {priorities.map((prio) => (
                  <MenuItem key={prio} value={prio}>
                    {prio}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReviewDialog;
